import {
    SimpleShowLayout,
    TextField,
    RichTextField,
    useResourceContext,
    usePermissions,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaShowView } from "shared/src/components/views/RaShowView";

export const UserShow = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
            <RaShowView
                {...props}
                actions={
                    <ToolbarWithHistory
                        back={true}
                        edit={permissions.vote({ resource, attribute: "edit" })}
                        delete={permissions.vote({ resource, attribute: "delete" })}
                    />
                }
            >
                <SimpleShowLayout>
                    <TextField label="equip.firstname" source="firstname" />
                    <TextField label="equip.lastname" source="lastname" />
                    <RichTextField
                        label="equip.email"
                        source="email"
                        type="email"
                    />
                </SimpleShowLayout>
            </RaShowView>
    );
};
